import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { BrandLogo } from '../../shared/components/icons';
import { COMPANY, SiteFooter } from '../../shared/components/SiteFooter';

const EFFECTIVE_DATE = '2026년 7월 21일';

export default function PrivacyPolicyPage() {
  return (
    <Shell>
      <Page>
        <Brand to="/">
          <BrandMark><BrandLogo size={30} /></BrandMark>
          <div>
            <BrandTitle>Auto Threads</BrandTitle>
            <BrandSubtitle>개인정보 처리방침</BrandSubtitle>
          </div>
        </Brand>

        <Doc>
        <DocHeader>
          <h1>개인정보 처리방침</h1>
          <Meta>시행일: {EFFECTIVE_DATE}</Meta>
          <Lead>
            Auto Threads(이하 &ldquo;서비스&rdquo;)는 「개인정보 보호법」 등 관련
            법령을 준수하며, 이용자의 개인정보를 보호하고 이와 관련한 고충을
            신속·원활하게 처리하기 위하여 다음과 같이 개인정보 처리방침을
            수립·공개합니다.
          </Lead>
        </DocHeader>

        <Contents aria-label="문서 목차">
          <strong>빠르게 찾아보기</strong>
          <ol>
            <li><a href="#section-1">1. 수집하는 개인정보 항목</a></li>
            <li><a href="#section-2">2. 개인정보의 수집·이용 목적</a></li>
            <li><a href="#section-3">3. 개인정보의 처리 및 보유 기간</a></li>
            <li><a href="#section-4">4. 개인정보의 제3자 제공</a></li>
            <li><a href="#section-5">5. 개인정보 처리의 위탁 및 외부 서비스 이용</a></li>
            <li><a href="#section-6">6. 개인정보의 파기 절차 및 방법</a></li>
            <li><a href="#section-7">7. 이용자의 권리·의무 및 행사 방법</a></li>
            <li><a href="#section-8">8. 개인정보의 안전성 확보 조치</a></li>
            <li><a href="#section-9">9. 쿠키 및 유사 기술의 사용</a></li>
            <li><a href="#section-10">10. 개인정보 보호책임자 및 문의</a></li>
            <li><a href="#section-11">11. 처리방침의 변경</a></li>
          </ol>
        </Contents>

        <Section id="section-1">
          <h2>1. 수집하는 개인정보 항목</h2>
          <p>서비스는 아래와 같은 개인정보를 수집할 수 있습니다.</p>
          <h3>회원가입 및 계정</h3>
          <ul>
            <li>필수: 이메일, 비밀번호, 이름, 휴대폰 번호</li>
            <li>선택: 우편번호, 주소, 상세 주소</li>
          </ul>
          <h3>Threads 계정 연동</h3>
          <ul>
            <li>
              Meta/Threads OAuth를 통해 제공되는 계정 식별 정보, 프로필 정보
              (사용자명, 프로필 이미지 등)
            </li>
            <li>연동 계정과 관련된 액세스·리프레시 토큰(서비스 운영에 필요한 범위)</li>
          </ul>
          <h3>서비스 이용 과정에서 생성·수집되는 정보</h3>
          <ul>
            <li>작성·예약·발행한 게시글 및 주제, 말투/톤 분석 결과</li>
            <li>예약·발행 이력, 알림 수신 설정(예: 메일 알림 on/off)</li>
            <li>
              서비스 이용 기록, 접속 로그, 기기·브라우저 정보, IP 주소 등
              자동 수집 정보
            </li>
          </ul>
        </Section>

        <Section id="section-2">
          <h2>2. 개인정보의 수집·이용 목적</h2>
          <ul>
            <li>회원 가입·인증, 본인 확인 및 계정 관리</li>
            <li>Threads 계정 연동 및 AI 기반 콘텐츠 생성·예약·자동 발행</li>
            <li>서비스 제공, 기능 개선, 오류 대응 및 고객 지원</li>
            <li>이용자가 동의한 경우 글 발행 등 서비스 관련 이메일 알림 발송</li>
            <li>부정 이용 방지, 보안, 약관·법령 준수</li>
          </ul>
        </Section>

        <Section id="section-3">
          <h2>3. 개인정보의 처리 및 보유 기간</h2>
          <p>
            원칙적으로 개인정보는 수집·이용 목적이 달성되면 지체 없이
            파기합니다. 다만 관련 법령에 따라 일정 기간 보관이 필요한 경우에는
            해당 기간 동안 보관합니다.
          </p>
          <ul>
            <li>회원 정보: 회원 탈퇴 시까지 (탈퇴 후 지체 없이 파기)</li>
            <li>
              서비스 이용 기록·게시 관련 데이터: 서비스 제공 및 분쟁 대응에
              필요한 기간 또는 관련 법령이 정한 기간
            </li>
            <li>
              전자상거래 등에서의 계약·청약철회 등에 관한 기록: 관련 법령에
              따른 기간
            </li>
          </ul>
        </Section>

        <Section id="section-4">
          <h2>4. 개인정보의 제3자 제공</h2>
          <p>
            서비스는 이용자의 개인정보를 제1조·제2조에서 고지한 범위 내에서
            처리하며, 이용자의 동의 없이 제3자에게 제공하지 않습니다. 다만
            다음의 경우에는 예외로 합니다.
          </p>
          <ul>
            <li>이용자가 사전에 동의한 경우</li>
            <li>법령에 의해 요구되는 경우</li>
          </ul>
        </Section>

        <Section id="section-5">
          <h2>5. 개인정보 처리의 위탁 및 외부 서비스 이용</h2>
          <p>
            원활한 서비스 제공을 위해 다음과 같은 외부 서비스를 이용할 수
            있으며, 이 과정에서 필요한 범위의 정보가 처리될 수 있습니다.
          </p>
          <ul>
            <li>Meta Platforms(Threads API): 계정 연동 및 게시물 등록·관리</li>
            <li>OpenAI 등 AI 제공 서비스: 콘텐츠·말투 생성 및 분석</li>
            <li>검색·리서치 API(예: Tavily): 콘텐츠 보조 정보 수집</li>
            <li>이메일 발송 서비스: 이용자가 동의한 알림 메일 발송</li>
            <li>클라우드·인프라 제공자: 서버 호스팅 및 데이터 저장</li>
          </ul>
          <p>
            위탁·연동 시 관련 법령에 따라 개인정보가 안전하게 관리되도록
            필요한 조치를 합니다.
          </p>
        </Section>

        <Section id="section-6">
          <h2>6. 개인정보의 파기 절차 및 방법</h2>
          <p>
            보유 기간이 경과하거나 처리 목적이 달성된 개인정보는 지체 없이
            파기합니다. 전자적 파일 형태는 복구·재생이 불가능한 방법으로
            삭제하고, 출력물 등은 분쇄 또는 소각합니다.
          </p>
        </Section>

        <Section id="section-7">
          <h2>7. 이용자의 권리·의무 및 행사 방법</h2>
          <p>이용자는 언제든지 다음과 같은 권리를 행사할 수 있습니다.</p>
          <ul>
            <li>개인정보 열람·정정·삭제·처리정지 요구</li>
            <li>동의 철회 및 회원 탈퇴</li>
            <li>메일 알림 등 선택적 처리에 대한 수신 변경</li>
          </ul>
          <p>
            권리 행사는 서비스 내 설정·계정 기능 또는 아래 문의 창구를 통해
            요청할 수 있으며, 서비스는 관련 법령에 따라 지체 없이
            조치합니다. 데이터 삭제 요청은{' '}
            <Link to="/data-deletion">사용자 데이터 삭제 안내</Link> 페이지를
            이용해 주세요.
          </p>
        </Section>

        <Section id="section-8">
          <h2>8. 개인정보의 안전성 확보 조치</h2>
          <ul>
            <li>비밀번호 등 중요 정보의 암호화 저장</li>
            <li>접근 권한 관리 및 인증 토큰 보호</li>
            <li>개인정보 취급 최소화 및 접근 통제</li>
            <li>보안 사고 대비를 위한 내부 관리 절차 운영</li>
          </ul>
        </Section>

        <Section id="section-9">
          <h2>9. 쿠키 및 유사 기술의 사용</h2>
          <p>
            서비스는 로그인 상태 유지, 이용 편의 제공을 위해 브라우저
            저장소(localStorage 등)에 인증 토큰 등 필요한 정보를 저장할 수
            있습니다. 브라우저 설정을 통해 저장 데이터를 삭제할 수 있으나,
            이 경우 일부 기능 이용이 제한될 수 있습니다.
          </p>
        </Section>

        <Section id="section-10">
          <h2>10. 개인정보 보호책임자 및 문의</h2>
          <p>
            개인정보 처리에 관한 문의, 불만 처리, 피해 구제 요청은 아래로
            연락해 주세요.
          </p>
          <ContactBox>
            <p>
              <strong>상호</strong> {COMPANY.name}
            </p>
            <p>
              <strong>대표</strong> {COMPANY.ceo}
            </p>
            <p>
              <strong>주소</strong> {COMPANY.address}
            </p>
            <p>
              <strong>사업자등록번호</strong> {COMPANY.businessNumber}
            </p>
            <p>
              <strong>전화</strong>{' '}
              <a href={`tel:${COMPANY.phone.replace(/-/g, '')}`}>
                {COMPANY.phone}
              </a>
            </p>
            <p>
              <strong>이메일</strong>{' '}
              <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>
            </p>
            <p>
              <strong>문의</strong>{' '}
              <Link to="/data-deletion">데이터 삭제 안내</Link>
            </p>
          </ContactBox>
        </Section>

        <Section id="section-11">
          <h2>11. 처리방침의 변경</h2>
          <p>
            본 개인정보 처리방침이 변경되는 경우, 변경 내용과 시행일을 서비스
            화면 또는 공지 가능한 방법으로 안내합니다. 중요한 변경이 있는
            경우 시행일 이전에 고지합니다.
          </p>
        </Section>

        <DocFooter>
          <p>본 방침은 {EFFECTIVE_DATE}부터 적용됩니다.</p>
          <NavLinks>
            <Link to="/login">로그인</Link>
            <span aria-hidden>·</span>
            <Link to="/register">회원가입</Link>
            <span aria-hidden>·</span>
            <Link to="/data-deletion">데이터 삭제</Link>
            <span aria-hidden>·</span>
            <Link to="/dashboard">서비스로 이동</Link>
          </NavLinks>
        </DocFooter>
      </Doc>
      </Page>
      <SiteFooter $compact />
    </Shell>
  );
}

const Shell = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background:
    radial-gradient(
      900px 480px at 50% -10%,
      ${({ theme }) => theme.colors.accentGlow} 0%,
      transparent 55%
    ),
    ${({ theme }) => theme.colors.background};
`;

const Page = styled.main`
  flex: 1;
  padding: 40px 20px 40px;
`;

const Brand = styled(Link)`
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  max-width: 760px;
  margin: 0 auto 28px;
  color: inherit;
`;

const BrandMark = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  font-size: 28px;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  line-height: 1;
  color: ${({ theme }) => theme.colors.primary};
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.border};
`;

const BrandTitle = styled.strong`
  display: block;
  font-size: 20px;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
`;

const BrandSubtitle = styled.span`
  display: block;
  margin-top: 2px;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.textSecondary};
`;

const Doc = styled.article`
  width: 100%;
  max-width: 760px;
  margin: 0 auto;
  padding: 36px 40px;
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius.xl};
  box-shadow: ${({ theme }) => theme.shadow.sm};
  animation: slideUp 0.4s ease both;

  @media (max-width: 640px) {
    padding: 28px 20px;
  }
`;

const DocHeader = styled.header`
  margin-bottom: 32px;
  padding-bottom: 24px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};

  h1 {
    font-size: 28px;
    font-weight: ${({ theme }) => theme.fontWeights.bold};
    letter-spacing: -0.02em;
    line-height: 1.2;
  }
`;

const Meta = styled.p`
  margin-top: 10px;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.textMuted};
`;

const Lead = styled.p`
  margin-top: 16px;
  font-size: 15px;
  line-height: 1.7;
  color: ${({ theme }) => theme.colors.textSecondary};
`;

const Section = styled.section`
  margin-bottom: 36px;
  scroll-margin-top: 24px;
  ul { list-style: disc; }
  ol { list-style: decimal; }

  h2 {
    margin-bottom: 10px;
    font-size: 17px;
    font-weight: 700;
    letter-spacing: -0.01em;
  }

  h3 {
    margin: 14px 0 8px;
    font-size: 14px;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.textPrimary};
  }

  p {
    font-size: 15px;
    line-height: 1.85;
    color: ${({ theme }) => theme.colors.textSecondary};
  }

  a {
    color: ${({ theme }) => theme.colors.primary};
    font-weight: 600;
  }

  ul {
    margin: 10px 0 0;
    padding-left: 1.2em;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  li {
    font-size: 15px;
    line-height: 1.8;
    color: ${({ theme }) => theme.colors.textSecondary};
  }
`;

const ContactBox = styled.div`
  margin-top: 12px;
  padding: 16px 18px;
  border-radius: ${({ theme }) => theme.radius.md};
  background: ${({ theme }) => theme.colors.surfaceMuted};
  border: 1px solid ${({ theme }) => theme.colors.border};

  p {
    font-size: 15px;
    line-height: 1.8;
    color: ${({ theme }) => theme.colors.textSecondary};
  }

  p + p {
    margin-top: 6px;
  }

  strong {
    display: inline-block;
    min-width: 88px;
    margin-right: 8px;
    color: ${({ theme }) => theme.colors.textPrimary};
  }

  a {
    color: ${({ theme }) => theme.colors.primary};
    font-weight: 600;
  }
`;

const DocFooter = styled.footer`
  margin-top: 8px;
  padding-top: 24px;
  border-top: 1px solid ${({ theme }) => theme.colors.border};
  text-align: center;

  p {
    font-size: 13px;
    color: ${({ theme }) => theme.colors.textMuted};
  }
`;

const NavLinks = styled.nav`
  margin-top: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  font-size: 13px;

  a {
    color: ${({ theme }) => theme.colors.primary};
    font-weight: 600;
  }

  span {
    color: ${({ theme }) => theme.colors.textMuted};
  }
`;

const Contents = styled.nav`
  margin-bottom: 32px;
  padding: 20px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius.lg};
  background: ${({ theme }) => theme.colors.surfaceMuted};
  strong { display: block; margin-bottom: 10px; font-size: 14px; }
  ol { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 2px 20px; }
  a {
    display: flex;
    align-items: center;
    min-height: 40px;
    padding: 6px 0;
    font-size: 13px;
    line-height: 1.5;
    color: ${({ theme }) => theme.colors.textSecondary};
    &:hover { color: ${({ theme }) => theme.colors.primary}; text-decoration: underline; }
  }
  @media (max-width: 600px) {
    padding: 16px;
    ol { grid-template-columns: 1fr; }
    a { min-height: 44px; }
  }
`;
